import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAiSettings } from '../api/aiSettingsApi';
export const getAiSettings = createAsyncThunk('parentApp/fetchAiSettings', async () => await fetchAiSettings());